const PNP_REFRESH_V1 = 'GROW-2792';
const TYPE_DESCRIPTION = '[Type: String][Vis.: high] - ';
const EXPERIMENT_DESCRIPTION = ' - A string in pricing experiment GROW-2792';
const CATEGORY = 'IPPM';

const ippmCopy = {
  BACK_TO_SURVEY: {
    id: 'Pricing.experimentIPPMCopy.BackToSurvey',
    defaultMessage: 'Back to survey',
    desc: {
      id: 'Pricing.experimentIPPMCopy.BackToSurvey',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  ENTERPRISE: {
    id: 'Pricing.experimentIPPMCopy.Enterprise',
    defaultMessage: `Need powerful admin tools, integrations, and collaboration features? <span id="contact">Contact Sales</span>`,
    desc: {
      id: 'Pricing.experimentIPPMCopy.Enterprise',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  PAGE_HEADING: {
    id: 'Pricing.experimentIPPMCopy.PageHeading',
    defaultMessage: 'Your survey includes paid features',
    desc: {
      id: 'Pricing.experimentIPPMCopy.PageHeading',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  UPGRADE: {
    id: 'Pricing.experimentIPPMCopy.Upgrade',
    defaultMessage: `Choose a plan to keep your added features. Or <span id="returnBackToSurvey">return to your survey</span> and remove paid features to send for free. <span id="education">Education discounts available</span>`,
    desc: {
      id: 'Pricing.experimentIPPMCopy.Upgrade',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
};

export default ippmCopy;
